import { useEffect, useReducer, useRef } from "react";

export function useScopedRequests(scopes) {
  const [, refresh] = useReducer((value) => value + 1, 0);
  const state = useRef({ mounted: true, latest: new Map(), pending: new Set(), scopes: {} });
  state.current.scopes = Object.fromEntries(
    Object.entries(scopes).map(([name, values]) => [name, JSON.stringify(values)]),
  );
  for (const [name, operation] of state.current.latest) {
    if (operation.scope !== state.current.scopes[name]) {
      state.current.latest.delete(name);
      state.current.pending.delete(operation);
    }
  }
  const current = (operation) =>
    state.current.mounted &&
    state.current.latest.get(operation.name) === operation &&
    state.current.scopes[operation.name] === operation.scope;
  useEffect(() => {
    state.current.mounted = true;
    return () => {
      state.current.mounted = false;
      state.current.latest.clear();
      state.current.pending.clear();
    };
  }, []);
  return {
    current,
    pending: [...state.current.pending].some(current),
    start(name, scope) {
      const operation = { name, scope: scope ? JSON.stringify(scope) : state.current.scopes[name] };
      const previous = state.current.latest.get(name);
      if (previous) state.current.pending.delete(previous);
      state.current.latest.set(name, operation);
      state.current.pending.add(operation);
      refresh();
      return operation;
    },
    finish(operation) {
      state.current.pending.delete(operation);
      if (state.current.mounted) refresh();
    },
  };
}
